// @flow
import connectWebActions             from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents }      from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks                from 'fg-frontend/src/components/safeBlankLinks';
import cookiesPolicy                 from 'fg-frontend/components/CookiesPolicy/index';
import phoneLink              		 from 'fg-frontend/components/PhoneLink';

import configureWebComponents from './configureWebComponents';
import configureWebActions    from './configureWebActions';

import 'fg-frontend/ramjet/liveValidation';
//import('./components/plUpload/fg.upload');                // PL upload
//import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, [ 'keyup' ]);
autoTitleLinksWithBlankTarget();
cookiesPolicy({
	imgSrc: '/img/cookies/bernard.png',
	enableTechnicalButton: true,
	messages: {
		cs: {
			technicalBtn: 'Odmítnout',
			perex: 'Chceme, aby pro vás bylo procházení webu co nejpříjemnější. Proto používáme soubory cookies, které nám pomáhají web neustále zlepšovat. Díky nim vám také můžeme zobrazovat relevantní obsah a&nbsp;personalizované reklamy. Se souhlasem můžeme některé údaje sdílet s&nbsp;našimi partnery (např. Google). Nastavení můžete kdykoli upravit nebo souhlas odvolat. Více najdete na stránce <a class="cookies-policy__link" href="/cs/informace-o-cookies">Informace o&nbsp;cookies</a>.',
		},
		en: {
			technicalBtn: 'Reject',
			perex: 'We want your browsing experience to be as pleasant as possible. That\'s why we use cookies, which help us constantly improve our website. They also allow us to show you relevant content and personalized ads. With your consent, we may share some data with our partners (e.g. Google). You can adjust your settings or withdraw your consent at any time. Find out more on the <a class="cookies-policy__link" href="/en/cookie-information">Cookie information</a> page.',
		},
  },
  settingsMessages: {
    cs: {
      marketingPerex: 'Umožňují nám a&nbsp;našim partnerům (např. Google) zobrazovat personalizované reklamy - i&nbsp;na jiných webech, které navštívíte. Více o&nbsp;tom, jak Google s&nbsp;daty pracuje, najdete v&nbsp;<a class="cookies-settings__link" href="https://business.safety.google/privacy/">Zásadách Google</a>.',
    },
    en: {
      marketingPerex: 'They allow us and our partners (e.g. Google) to show personalized ads — even on other websites you visit. You can find more about how Google works with data in the <a class="cookies-settings__link" href="https://business.safety.google/privacy/">Google Privacy & Terms</a>.',
    },
	}
});
phoneLink();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWeb.js